import React from 'react';
import { motion } from 'framer-motion';
import { Zap, FlaskConical, Atom, Zap as Electron, Beaker, Leaf, Trophy } from 'lucide-react';
const volumes = [{
  year: '1°',
  color: 'bg-blue-500'
}, {
  year: '2°',
  color: 'bg-green-500'
}, {
  year: '3°',
  color: 'bg-orange-500'
}, {
  year: '4°',
  color: 'bg-purple-500'
}, {
  year: '5°',
  color: 'bg-slate-500'
}];
const details = [{
  title: 'CUADERNILLO 1 — 1° Año: Introducción a la Química y Sistemas Materiales',
  desc: 'Conceptos fundamentales, materia, propiedades, estados de agregación, modelo de partículas, transformaciones físicas y químicas.',
  icon: <FlaskConical className="text-blue-600" data-id="element-172" />
}, {
  title: 'CUADERNILLO 2 — 2° Año: Estructura Atómica y Tabla Periódica',
  desc: 'Modelos atómicos, partículas subatómicas, Z-A-N, isótopos, iones, tabla periódica y propiedades periódicas.',
  icon: <Atom className="text-green-600" data-id="element-173" />
}, {
  title: 'CUADERNILLO 3 — 3° Año: El Mapa Electrónico y las Uniones Químicas',
  desc: 'Números cuánticos, configuración electrónica, bloques de la tabla, enlace iónico, covalente y metálico, estructuras de Lewis.',
  icon: <Electron className="text-orange-600" data-id="element-174" />
}, {
  title: 'CUADERNILLO 4 — 4° Año: Química Inorgánica y Reacciones',
  desc: 'Nomenclatura inorgánica, óxidos, hidróxidos, ácidos, sales, reacciones químicas y estequiometría.',
  icon: <Beaker className="text-purple-600" data-id="element-175" />
}, {
  title: 'CUADERNILLO 5 — 5° Año: Química Orgánica, Salud y Ambiente',
  desc: 'Compuestos orgánicos, funciones oxigenadas y nitrogenadas, polímeros, bioquímica básica y química ambiental.',
  icon: <Leaf className="text-slate-600" data-id="element-176" />
}];
export function ProductBreakdown() {
  return <section className="py-6 md:py-12 px-4 max-w-4xl mx-auto" data-id="element-177">
      <div className="text-center mb-6 md:mb-10" data-id="element-178">
        <div className="inline-flex items-center gap-2 text-blue-600 font-black tracking-widest text-sm uppercase mb-4" data-id="element-179">
          <Zap size={18} className="fill-blue-600" data-id="element-180" />
          <span data-id="element-181">Química en Acción</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 leading-tight" data-id="element-182">
          MEGAPACK QUÍMICA EN ACCIÓN
        </h2>
        <p className="text-slate-600 font-bold text-sm md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-183">
          5 cuadernillos organizados por año. +600 páginas con teoría clara,
          actividades secuenciadas, rúbricas, experiencias de laboratorio y
          proyectos integradores.
        </p>
      </div>

      <div className="grid grid-cols-5 gap-2 md:gap-4 mb-8 md:mb-12" data-id="element-184">
        {volumes.map((v, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className={`${v.color} aspect-[3/4] rounded-lg md:rounded-xl flex flex-col items-center justify-center text-white shadow-lg relative overflow-hidden group`} data-id="element-185">
            <span className={`font-black ${v.isSpecial ? 'text-[10px] md:text-xs' : 'text-xl md:text-2xl'}`} data-id="element-186">
              {v.year}
            </span>
            {v.isSpecial && <Trophy size={14} className="mt-1" data-id="element-187" />}
          </motion.div>)}
      </div>

      <div className="space-y-4" data-id="element-188">
        {details.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-189">
            <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-190">
              {item.icon}
            </div>
            <div data-id="element-191">
              <h4 className="font-black text-slate-900 text-sm md:text-lg mb-1 leading-tight" data-id="element-192">
                {item.title}
              </h4>
              <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium" data-id="element-193">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}